import React, { Component } from 'react';
import {
    withRouter
} from 'react-router-dom';
import {
    Page,
    Text,
    Card,
    Button,
    BlockStack,
    Icon,
} from '@shopify/polaris';
import {
    LockMajor
} from '@shopify/polaris-icons';
import './index.scss';
// import LightningIcon from '../../../assets/LightningIcon';

// 翻译
import Language from '../../../i18n/Language';
import utils from '../../../utils/utils';
import { connect } from 'react-redux'
import { store } from '../../../redux/store';
import FaqCardBox from '../../../components/FaqCardBox';
import FooterTrustHelp from '../../../components/FooterTrustHelp';
const t = Language;
class SpeedOptimization extends Component {
    state = {
        ShortCard: [
            {
                id: 31,
                title: "Keyword Search",
                img: '/indoorImg/new/KeywordSearch.png',
                url: "/keywordRearch/keywords-search",
                desc: "Access the latest Google keyword search trends to understand which keywords users are more likely to search for.",
                btn: 'Explore Trends',
                btnType: 1, // 1 - primary
                plan: 1,

            },
            {
                id: 32,
                title: "My Website Keywords",
                img: '/indoorImg/new/MyWebKeyword.png',
                url: "/keywordRearch/my-website-keywords",
                desc: "Get insights into your website's keyword performance and see which keywords are driving traffic.",
                btn: 'Analyze My Keywords',
                btnType: 1, // 1 - primary
                plan: 3,

            },
            {
                id: 34,
                title: "Keyword Gap",
                img: '/indoorImg/new/KeywordGap.png',
                url: "/keywordRearch/keywords-gap",
                desc: "Compare your website with competitors to discover untapped keyword opportunities.",
                btn: 'Compare Keywords',
                btnType: 0, // 1 - primary
                plan: 3,

            },
            {
                id: 33,
                title: "Competitive Keyword Monitoring",
                img: '/indoorImg/new/ComKeywordMon.png',
                url: "/keywordRearch/keywords-monitor",
                desc: "Monitor competitors' website keywords to gain insights into their strategies.",
                btn: 'Track Competitors',
                btnType: 0, // 1 - primary
                plan: 3,

            },
            {
                id: 35,
                title: "Keyword List",
                img: '/indoorImg/new/KeywordList.png',
                url: "/keywordRearch/keywords-list",
                desc: "A summary of your saved keywords that can be applied to your pages with a single click.",
                btn: 'Apply Keywords',
                btnType: 0, // 1 - primary
                plan: 3,

            },
        ],
        questionList: {
            sa_wm_seo: {
                title: "What is the impact of keyword research on SEO?",
                tag: [
                    "Keyword research is at the core of any SEO strategy. By conducting thorough keyword research, you can identify the terms and phrases that users are most frequently searching for and optimize your content accordingly. Using high-search-volume, low-competition keywords can help your site gain traffic more quickly. Additionally, regularly tracking keyword performance allows you to adjust your content strategy to keep or improve search engine rankings as trends change.",
                ]
            },
        }, // 问题列表
    }

    // 跳转
    jumpUrl = (url) => {
        utils.routeJump(this, url);
    }

    render() {
        const {
            // LongCard,
            ShortCard,
            questionList,

        } = this.state;

        // 判断是否shopify内嵌模式
        const shopifyMode = store.getState().public.isShowTopMenu || 1;

        // 等级
        const level = store.getState().public.level;

        // 常见问题
        const FrequentAsk = <FaqCardBox FaqList={questionList} />

        // 底部
        const FooterHelpBox = <FooterTrustHelp />

        // 最终页面
        const lockIcon = (plan = 1) => {
            return <div className='PAY_ICON_NEW'>
                <Icon source={LockMajor} tone="base" /> {plan === 2 ? t("Pro plan") : t("Pre plan")}
            </div>
        }
        const pageContent = <Page
            title={shopifyMode ? t("Keyword Research") : ''}
        >
            <title>SEOAnt - Keyword Research</title>
            <div className={`row_seo_analytics`}>
                <BlockStack gap={400}>
                    <div className='ShortCard'>
                        {
                            ShortCard.map(item => {
                                return <Card key={item.title}>
                                    <div className='ShortCard_Info'>
                                        <div className='SC_img'><img alt='' src={item.img} /></div>
                                        <div className='SC_mes'>
                                            <div className='SC_info'>
                                                <BlockStack gap={200}>
                                                    <div className='flex_layout'>
                                                        <Text variant="headingMd" as="h2">{t(item.title)}</Text>
                                                        {(item.plan === 1 || (item.plan === 2 && level === 2) || level === 3) ? null : lockIcon(item.plan)}
                                                    </div>
                                                    <Text as="p" fontWeight="regular">{t(item.desc)}</Text>
                                                </BlockStack>
                                            </div>
                                            <div>
                                                <Button onClick={() => this.jumpUrl(item.url)} variant={Boolean(item?.btnType) && "primary"}>{t(item.btn)}</Button>
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            })
                        }
                    </div>
                    {FrequentAsk}
                </BlockStack>
            </div>

            {FooterHelpBox}
        </Page>

        return pageContent;
    }
}

const mapStateToProps = state => {
    return state;
}

SpeedOptimization = connect(
    mapStateToProps,
)(SpeedOptimization);

export default withRouter(SpeedOptimization);